<ng-container *transloco="let t" class="container">
  <div class="p-2">
    <div class="modal-header">
      <button type="button" class="btn-close" aria-label="Close" (click)="onDismissClick()">
      </button>
      <div class="race-profile-dialog_badge header-badge"><p
        class="font-16 font-d-18 futura-heavy">{{ t("app.common.waypoint.short") }}{{ waypoint?.ordinalNumber }}</p>
      </div>
    </div>
    <div class="modal-body body">
      <div class="row">
        <div class="col-md-6 col-12 pt-1">
          <p class="map-label fw-light">{{ t("app.common.waypoint.name") }}</p>
          <p class="map-content fw-bold pt-1">
            <app-language-output [hrLabel]="waypoint?.pointNameHr" [enLabel]="waypoint?.pointNameEn"
                                 [itLabel]="waypoint?.pointNameIt" [srLabel]="waypoint?.pointNameSr" [bsLabel]="waypoint?.pointNameBs"
                                 [siLabel]="waypoint?.pointNameSlo" [languages]="languages"/>
          </p>
        </div>
        <div class="col-md-6 col-12 pt-3">
          <p class="map-label fw-light">{{ t("app.common.waypoint.altitude") }}</p>
          <p
            class="map-content fw-bold pt-1"> {{ waypoint?.elevation ? (waypoint?.elevation | raceLengthFormat:translocoService.getActiveLang()) : '-' }}
          </p>
        </div>
        <div class="col-md-6 col-12 pt-3">
          <p class="map-label fw-light">{{ t("app.common.waypoint.distance.total") }}</p>
          <p
            class="map-content fw-bold pt-1">{{ waypoint?.distanceFromStart ? (waypoint?.distanceFromStart | raceLengthFormat:translocoService.getActiveLang()) : '-' }}</p>
        </div>
        <div class="col-md-6 col-12 pt-3">
          <p class="map-label fw-light">{{ t("app.common.waypoint.distance.from") }}
            <app-language-output [hrLabel]="previousWaypoint?.pointNameHr" [enLabel]="previousWaypoint?.pointNameEn"
                                 [itLabel]="previousWaypoint?.pointNameIt" [srLabel]="previousWaypoint?.pointNameSr" [bsLabel]="previousWaypoint?.pointNameBs"
                                 [siLabel]="previousWaypoint?.pointNameSlo" [languages]="languages"/>
          </p>
          <p class="map-content fw-bold pt-1">
            {{ (waypoint?.distanceFromStart ?? 0) - (previousWaypoint?.distanceFromStart ?? 0) ? ((waypoint?.distanceFromStart ?? 0) - (previousWaypoint?.distanceFromStart ?? 0) | raceLengthFormat:translocoService.getActiveLang()) : '-' }}
        </div>
        <div class="col-md-6 col-12 pt-3">
          <p class="map-label fw-light">{{ t("app.common.waypoint.elevation.gain.total") }}</p>
          <p
            class="map-content fw-bold pt-1">{{ elevationStats?.gainFromStart ? (elevationStats?.gainFromStart | raceLengthFormat:translocoService.getActiveLang()) : '0' }}
            +</p></div>
        <div class="col-md-6 col-12 pt-3">
          <p class="map-label fw-light">{{ t("app.common.waypoint.elevation.gain.from") }}
            <app-language-output [hrLabel]="previousWaypoint?.pointNameHr" [enLabel]="previousWaypoint?.pointNameEn"
                                 [itLabel]="previousWaypoint?.pointNameIt" [srLabel]="previousWaypoint?.pointNameSr" [bsLabel]="previousWaypoint?.pointNameBs"
                                 [siLabel]="previousWaypoint?.pointNameSlo" [languages]="languages"/>
          </p>
          <p
            class="map-content fw-bold pt-1">{{ elevationStats?.gainFromPrevious ? (elevationStats?.gainFromPrevious | raceLengthFormat:translocoService.getActiveLang()) : '0' }}
            +</p>
        </div>
        <div class="col-md-6 col-12 pt-3">
          <p class="map-label fw-light">{{ t("app.common.waypoint.elevation.loss.total") }}</p>
          <p
            class="map-content fw-bold pt-1">{{ elevationStats?.lossFromStart ? (elevationStats?.lossFromStart | raceLengthFormat:translocoService.getActiveLang()) : '0' }}
            -</p>
        </div>
        <div class="col-md-6 col-12 pt-3">
          <p class="map-label fw-light">{{ t("app.common.waypoint.elevation.loss.from") }}
            <app-language-output [hrLabel]="previousWaypoint?.pointNameHr" [enLabel]="previousWaypoint?.pointNameEn"
                                 [itLabel]="previousWaypoint?.pointNameIt"
                                 [srLabel]="previousWaypoint?.pointNameSr"
                                 [bsLabel]="previousWaypoint?.pointNameBs"
                                 [siLabel]="previousWaypoint?.pointNameSlo" [languages]="languages"/>
          </p>
          <p
            class="map-content fw-bold pt-1">{{ elevationStats?.lossFromPrevious ? (elevationStats?.lossFromPrevious | raceLengthFormat:translocoService.getActiveLang()) : '0' }}
            -</p>
        </div>
        @if ((waypoint?.markerTypes?.length ?? 0) > 0) {
          <div class="col-12 pt-3">
            <p class="map-label fw-light">{{ t("leaflet.maps.local.services") }}</p>
            <div class="grid-container grid-container--waypoints pt-3">
              @for (marker of waypoint?.markerTypes;track marker) {
                <div class="grid-item d-flex flex-row align-items-center justify-content-start">
                  <img [src]="waypointTypeIcons[marker]" width="20">
                  <p class="map-content fw-bold ps-2">
                    {{ t("app.common.waypoint.marker.types." + marker) }}
                  </p>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</ng-container>
